import westCoastLaunch from './files/Tour/stops/west-coast-launch.jpg';
import phoenix from './files/Tour/stops/phoenix.jpg';
import austin from './files/Tour/stops/austin.jpg';
import houston from './files/Tour/stops/houston.jpg';
import batonRouge from './files/Tour/stops/baton-rouge.jpg';
import birmingham from './files/Tour/stops/birmingham.jpg';
import huntsville from './files/Tour/stops/huntsville.jpg';
import nashville from './files/Tour/stops/nashville.jpg';
import eastCoastLaunch from './files/Tour/stops/east-coast-launch.jpg';
import atlanta from './files/Tour/stops/atlanta.jpg';
import charleston from './files/Tour/stops/charleston.jpg';
import wilmington from './files/Tour/stops/wilmington.jpg';
import newportNews from './files/Tour/stops/newport-news.jpg';
import stLouis from './files/Tour/stops/st-louis.jpg';
import oceanCity from './files/Tour/stops/ocean-city.jpg';
import pittsburgh from './files/Tour/stops/pittsburgh.jpg';
import hershey from './files/Tour/stops/hershey.jpg';
import louisville from './files/Tour/stops/louisville.jpg';

const stopPhotos = {
  'west-coast-launch': westCoastLaunch,
  'east-coast-launch': eastCoastLaunch,
  phoenix,
  austin,
  houston,
  'baton-rouge': batonRouge,
  birmingham,
  huntsville,
  nashville,
  atlanta,
  charleston,
  wilmington,
  'newport-news': newportNews,
  'st-louis': stLouis,
  'ocean-city': oceanCity,
  pittsburgh,
  hershey,
  louisville,
};

export default stopPhotos;
